module.exports = __webpack_public_path__ + "img/SolidHeight.722174fc.jpg";